import rawAssetsList from './combined-assets/index.js'
import { createCombined } from './create-combined.js'

const combinedAssetList = rawAssetsList.map((assetDef) => createCombined(assetDef))

export { createCombined } from './create-combined.js'

export default combinedAssetList
